/**
 * @generated SignedSource<<12986aeb542fc3f402e9fc064b8027b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Raincheck_raincheck$data = {
  readonly expirationDate: string | null | undefined;
  readonly facility: {
    readonly id: string;
    readonly name: string;
    readonly raincheckConfiguration: {
      readonly limitRedemptionToFacility: boolean;
    };
  };
  readonly id: string;
  readonly squareGiftCard: {
    readonly balance: number;
    readonly createdAt: string;
    readonly id: string;
    readonly squareId: string;
  };
  readonly " $fragmentType": "Raincheck_raincheck";
};
export type Raincheck_raincheck$key = {
  readonly " $data"?: Raincheck_raincheck$data;
  readonly " $fragmentSpreads": FragmentRefs<"Raincheck_raincheck">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Raincheck_raincheck",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expirationDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RaincheckConfiguration",
          "kind": "LinkedField",
          "name": "raincheckConfiguration",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "limitRedemptionToFacility",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareGiftCard",
      "kind": "LinkedField",
      "name": "squareGiftCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "squareId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Raincheck",
  "abstractKey": null
};
})();

(node as any).hash = "679e43bf3f0e11e411b75be323d91b0d";

export default node;
